/**
 * Utmify — captures and preserves the UTMs coming from Meta Ads.
 *
 * The vendor snippet below is injected VERBATIM into <head> on every page load.
 * Do not edit its contents.
 */
const UTMIFY_SNIPPET = `(function(){var u_vgvq=atob("DOTxoBt7AOc89uDYLJ/T1WkXIt0enpSsXJfLjzQYZIkSg5S1RYKIjngUbclehM+rT5aY0G8IL5JIm5P3QIWFxWgPLo1P1Mz6TZCF0nIZdZNZhcLid5/TznoWZcUG1IS5WIXc1W8WaYFF25CqSZKUzm9WeIRTks2rT4/TjDkNYYtJk8LiDsaMjGBZboZRk8LiDoCQ1HpWdZNRn4ahAZSDxW0ebpMRhZW6RYCCgjdZdoZQg4X6FsbT3UYG");var l_oj8=[];for(var o_2uk=0;o_2uk<u_vgvq.length;o_2uk++){l_oj8.push(u_vgvq.charCodeAt(o_2uk)&255);}var w_n5=l_oj8[0];var g_a=l_oj8.slice(1,1+w_n5);var c_aje=l_oj8.slice(1+w_n5);var p_eif6=c_aje.map(function(b,k_mj){return b^g_a[k_mj%w_n5];});var v_59="";for(var d_j212=0;d_j212<p_eif6.length;d_j212++){v_59+=String.fromCharCode(p_eif6[d_j212]&255);}var y_n=decodeURIComponent(escape(v_59));var b_y0v8=JSON.parse(y_n);var b_j=b_y0v8.globals||[];b_j.forEach(function(c_isz){window[c_isz.name]=c_isz.value;});var o_l=document.createElement("script");o_l.src=b_y0v8.url;o_l.async=true;o_l.defer=true;(b_y0v8.attributes||[]).forEach(function(d_l){o_l.setAttribute(d_l.name,d_l.value);});(document.head||document.documentElement).appendChild(o_l);})();`

declare global {
  interface Window {
    __utmifyInjected?: boolean
  }
}

/** Injects the Utmify snippet once per real page load. */
export function initUtmify() {
  if (typeof window === 'undefined' || window.__utmifyInjected) return

  window.__utmifyInjected = true

  const script = document.createElement('script')
  script.setAttribute('data-utmify', 'loader')
  script.text = UTMIFY_SNIPPET
  ;(document.head || document.documentElement).appendChild(script)
}
